import { useQuery } from '@tanstack/react-query';
import { fetchPrice, type CoinPrice } from '../lib/prices';

/**
 * Live USD price + 24h change for several coins at once (Binance → CoinGecko).
 * Missing symbols are simply absent from the map — callers fall back to their
 * own baseline. Refreshes every 30s.
 */
export function useCoinPrices(symbols: string[]) {
  const key = [...symbols].sort().join(',');
  return useQuery({
    queryKey: ['prices', key],
    queryFn: async () => {
      const out: Record<string, CoinPrice> = {};
      await Promise.all(
        symbols.map(async (s) => {
          try {
            out[s] = await fetchPrice(s);
          } catch {
            /* leave missing — caller keeps its baseline */
          }
        }),
      );
      return out;
    },
    staleTime: 30_000,
    refetchInterval: 30_000,
    refetchOnWindowFocus: false,
  });
}
